import { useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useUploadMigracion } from "../../hooks/useUploadMigracion";

type CampaignType = "MIGRATION" | "FIDELIZATION";

interface SaveMigracionProps {
  campaignType: CampaignType;
}

export const SaveMigracion = ({ campaignType }: SaveMigracionProps) => {
  const [file, setFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const { upload, loading } = useUploadMigracion();

  const resetFileInput = () => {
    setFile(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleUpload = () => {
    if (!file) {
      alert("Selecciona un archivo");
      return;
    }

    upload(
      { file, campaignType },
      {
        onSuccess: () => {
          resetFileInput();
        },
      }
    );
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] ?? null;
    setFile(selectedFile);
    event.target.value = "";
  };
  const handleDownloadTemplate = () => {
  const data = [
    [
      "identificación",
      "nombre o razón social",
      "plan",
      "zona",
      "equipo",
      "fecha de instalación",
    ],
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(data);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    campaignType === "MIGRATION" ? "Migración" : "Fidelización"
  );

  XLSX.writeFile(
    workbook,
    `plantilla_${campaignType === "MIGRATION" ? "migracion" : "fidelizacion"}.xlsx`
  );
};
  return (
    <Box>
      <Card sx={{ maxWidth: 700, borderRadius: 3, boxShadow: 3 }}>
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3}>
            <Box>
              <Typography variant="h4" fontWeight={700}>
                Carga de archivo de{" "}
                {campaignType === "MIGRATION" ? "Migración" : "Fidelización"}
              </Typography>

              <Typography variant="body1" color="text.secondary" mt={1}>
                Sube un archivo CSV o XLSX para procesar.
              </Typography>
            </Box>

            <Box
              sx={{
                border: "1px dashed #c4c4c4",
                borderRadius: 2,
                p: 3,
                backgroundColor: "#fafafa",
              }}
            >
              <Stack spacing={2}>
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<UploadFileIcon />}
                  sx={{ width: "fit-content" }}
                  disabled={loading}
                >
                  Seleccionar archivo
                  <input
                    ref={fileInputRef}
                    hidden
                    type="file"
                    accept=".csv,.xlsx,.xls"
                    onChange={handleFileChange}
                  />
                </Button>

                <Typography variant="body2" color="text.secondary">
                  {file
                    ? `Archivo seleccionado: ${file.name}`
                    : "No has seleccionado ningún archivo"}
                </Typography>
              </Stack>
            </Box>

            <Box display="flex" gap={2}>
              <Button
                variant="contained"
                onClick={handleUpload}
                disabled={!file || loading}
                sx={{ borderRadius: 2, px: 4 }}
              >
                {loading ? "Subiendo..." : "Subir archivo"}
              </Button>

              <Button
                variant="contained"
                color="success"
                onClick={handleDownloadTemplate}
                disabled={loading}
                sx={{ borderRadius: 2, px: 4 }}
              >
                Descargar plantilla
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};